var map = {
	"./forgot-password-appedology.vue": [
		71729,
		1729
	],
	"./forgot-password-default.vue": [
		17872,
		7872
	],
	"./forgot-password-proglobal.vue": [
		28343,
		8343
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 30137;
module.exports = webpackAsyncContext;